/* eslint-disable max-len */
const ArmsSVG = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
    >
      <g transform="matrix(1,0,0,1,0,-128)">
        <g className="arms-svg" transform="matrix(1,0,0,1,0,-768)">
          <g className="svg-background" transform="matrix(1,0,0,1,-128,0)">
            <path
              d="M147,922L151,926L151,930L152,931L152,932L151,933L151,937L152,938L152,945L151,946L151,951L172,951L172,946L171.5,945L171.5,938L172,937L172,933L171,932L171,931L172,930L172,926L171,925L171,922L172,920.5L171,919L171,917L172,916L172,913L171,912L171,907L167,903L166,903L164.5,904L163,903L160.021,903L158.575,904L156.992,903L154.047,903L152.506,904L151,903L145.5,909.5L147,922Z"
              style={{ fillOpacity: 0.76 }}
            />
          </g>
          <g className="color_02" transform="matrix(1,0,0,1,-128,0)">
            <path
              d="M147,908L144,908L144,919L147,922L147,908ZM154,903L151,903L151,913L154,913L154,903ZM160,903L157,903L157,913L160,913L160,903ZM166,903L163,903L163,913L166,913L166,903ZM172,906L169,906L169,913L172,913L172,906Z"
              // style={{ fill: "rgb(136,136,136)" }}
            />
          </g>
          <g className="color_01" transform="matrix(1,0,0,1,-128,0)">
            <path
              d="M176,950L148,950L148,953L176,953L176,950ZM172,937L151,937L151,946L172,946L172,937ZM156,941C156,940.448 155.552,940 155,940L154,940C153.448,940 153,940.448 153,941L153,942C153,942.552 153.448,943 154,943L155,943C155.552,943 156,942.552 156,942L156,941ZM166,941C166,940.448 165.552,940 165,940L164,940C163.448,940 163,940.448 163,941L163,942C163,942.552 163.448,943 164,943L165,943C165.552,943 166,942.552 166,942L166,941ZM161,941C161,940.448 160.552,940 160,940L159,940C158.448,940 158,940.448 158,941L158,942C158,942.552 158.448,943 159,943L160,943C160.552,943 161,942.552 161,942L161,941ZM171,941C171,940.448 170.552,940 170,940L169,940C168.448,940 168,940.448 168,941L168,942C168,942.552 168.448,943 169,943L170,943C170.552,943 171,942.552 171,942L171,941ZM172,930L151,930L151,933L172,933L172,930ZM172,917C172,917 172,916 171,916L152,916C151,916 151,917 151,917L151,926L172,926.045L172,917ZM156,920C156,919.448 155.552,919 155,919L154,919C153.448,919 153,919.448 153,920L153,921C153,921.552 153.448,922 154,922L155,922C155.552,922 156,921.552 156,921L156,920ZM166,920C166,919.448 165.552,919 165,919L164,919C163.448,919 163,919.448 163,920L163,921C163,921.552 163.448,922 164,922L165,922C165.552,922 166,921.552 166,921L166,920ZM161,920C161,919.448 160.552,919 160,919L159,919C158.448,919 158,919.448 158,920L158,921C158,921.552 158.448,922 159,922L160,922C160.552,922 161,921.552 161,921L161,920ZM171,920C171,919.448 170.552,919 170,919L169,919C168.448,919 168,919.448 168,920L168,921C168,921.552 168.448,922 169,922L170,922C170.552,922 171,921.552 171,921L171,920Z"
              // style={{ fill: "rgb(190,190,190)" }}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArmsSVG;
